<template>
  <div class="makeLocationImage">
    <div
      id="make_container"
      :style="{ height: windowHeight + 'px', width: windowWidth + 'px' }"
    >
      <el-amap-search-box
        v-if="type === '板块规划'"
        class="map-search-box"
        :search-option="searchOption"
        :on-search-result="onSearchResult"
      >
      </el-amap-search-box>
      <el-amap
        class="amap-box"
        vid="make_map"
        ref="make_map"
        :zoom="zoom"
        :center="center"
        :amap-manager="amapManager"
        :events="events"
      >
        <el-amap-marker
          v-if="markers.length > 0"
          vid="real_search_marker"
          :position="markers"
        ></el-amap-marker>
        <el-amap-polyline
          v-for="(value, key) of realMarkers"
          :key="'polyline' + key"
          editable="false"
          :path="value.line"
          strokeColor="#F84F39"
          strokeWeight="3"
          strokeStyle="dashed"
        ></el-amap-polyline>
        <el-amap-marker
          :vid="'newRealMarker' + key"
          v-for="(value, key) of realMarkers"
          :key="'newRealMarker' + key"
          :position="value.marker"
          icon="./../../static/images/marker7.png"
          :offset="[-16, -25]"
        >
        </el-amap-marker>

        <el-amap-polyline
          v-for="(value, key) of landMarkers"
          :key="'polyline' + key"
          editable="false"
          :path="value.line"
          strokeColor="red"
          strokeWeight="2"
        ></el-amap-polyline>
        <el-amap-marker
          :vid="'newRealMarker' + key"
          v-for="(value, key) of landMarkers"
          :key="'landMarker' + key"
          :position="value.marker"
          icon="./../../static/images/marker.png"
          :offset="[-16, -25]"
        >
        </el-amap-marker>

        <el-amap-polyline
          v-for="(value, key) of schoolMarkers"
          :key="'polyline' + key"
          editable="false"
          :path="value.line"
          strokeColor="red"
          strokeWeight="2"
        ></el-amap-polyline>
        <el-amap-marker
          :vid="'newRealMarker' + key"
          v-for="(value, key) of schoolMarkers"
          :key="'schoolMarkers' + key"
          :position="value.marker"
          icon="./../../static/images/marker.png"
          :offset="[-16, -25]"
        >
        </el-amap-marker>
      </el-amap>
    </div>

    <div class="color-note" v-if="type === '板块规划'">
      <div
        v-for="(val, key) in colorMap"
        :key="key"
        :style="{ 'background-color': val }"
      >
        {{ key }}
      </div>
    </div>
    <div class="color-note" v-if="type === '板块热力'">
      <el-select
        v-model="value"
        @change="drawHeatMap"
        placeholder="请选择热力图"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div class="color-right" v-if="type === '板块配套'">
      <div>图例</div>
      <div
        v-for="(item, index) in colorPtMap"
        @click="changeColor(item.txt)"
        :key="index"
        class="color-item"
      >
        <div
          class="color-circle"
          :style="{ 'background-color': item.color }"
        ></div>
        <span>{{ item.txt }}</span>
      </div>
      <div
        v-if="type === '板块配套' && pttype !== '全部'"
        @click="changeColor('全部')"
        class="color-right-btn"
      >
        清除筛选
      </div>
    </div>

    <div
      class="color-right"
      v-if="type === '板块规控及重要规划'"
      style="align-items: flex-start"
    >
      <div style="margin-left: 20px">图例</div>
      <div v-for="(item, index) in colorKgMap" :key="index" class="color-item">
        <div
          class="color-cell"
          :style="{ 'background-color': item.color }"
        ></div>
        <span>{{ item.txt }}用地</span>
      </div>
      <el-button type="primary" @click="drawPoster" style="margin-top: 20px"
        >生成海报</el-button
      >
    </div>
    <div
      class="color-right"
      v-if="type === '板块新盘分布'"
      style="align-items: flex-start"
    >
      <div style="margin-left: 20px">图例</div>
      <div v-for="(item, index) in colorNEMap" :key="index" class="color-item">
        <div
          class="color-circle"
          :style="{ 'background-color': item.color }"
        ></div>
        <span>{{ item.txt }}</span>
      </div>
    </div>
    <div class="choose-area" v-if="type === '控规'">
      <el-select
        v-model="areaIdList"
        filterable
        placeholder="选择板块"
        default-first-option
        multiple
      >
        <el-option-group
          v-for="group in areaList"
          :key="group.label"
          :label="group.label"
        >
          <el-option
            v-for="item in group.options"
            :key="item.id"
            :label="item.area_name"
            :value="item.id"
          >
          </el-option>
        </el-option-group>
      </el-select>
      <el-button type="primary" @click="drawAreaPlanImage">查控规图</el-button>
      <el-button type="primary" @click="drawAreaPlanCell">已画地块</el-button>
    </div>

    <div
      class="color-note"
      v-if="
        currentArea === '全城' &&
        ['新房', '待首开', '公示登记', '土拍'].includes(type) &&
        sizeLevel < 3
      "
      style="background-color: #ff0000"
      @click="changeSize"
    >
      <div>{{ sizeLevel }}</div>
    </div>

    <div
      class="color-note"
      v-if="type === '地铁图'"
      style="background-color: #ffffff"
    >
      <el-select
        v-model="curline"
        @change="drawOneSubway"
        placeholder="请选择地铁线路"
      >
        <el-option
          v-for="item in sublines"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <p>当前：宽{{ windowWidth }}，高{{ windowHeight }}</p>
      <p>
        宽度:
        <input type="number" style="width: 50px" v-model="widthSet" /> 高度:
        <input type="number" style="width: 50px" v-model="heightSet" />
        <button @click="resetWindow">重置</button>
      </p>
    </div>
    <canvas ref="canvasPoster" style="position: absolute; left: -100%"></canvas>
    <div class="image-background2" v-if="mpCode">
      <div class="image-preview2">
        <span class="close2" @click="mpCode = null">关闭</span>
        <el-image
          :src="mpCode"
          :preview-src-list="[mpCode]"
          style="height: 400px; width: 600px"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { AMapManager } from "vue-amap";

// 导入配置
import { subwayName, subwayColor, subwayStatus, sublines } from './config/subwayConfig'
import { colorMap, colorPtMap, colorNEMap, colorKgMap } from './config/colorConfig'
import { heatmapOptions } from './config/mapConfig'

// 导入方法模块
import subwayMethods from './methods/subway'
import bindDistrictMethods from './methods/bindDistrict'
import bindAreaMethods from './methods/bindArea'
import bindEstateMethods from './methods/bindEstate'
import bindLandMethods from './methods/bindLand'
import bindHeatmapMethods from './methods/bindHeatmap'
import bindFacilityMethods from './methods/bindFacility'
import bindPlanMethods from './methods/bindPlan'
import bindSpecialMethods from './methods/bindSpecial'
import bindHandlerMethods from './methods/bindHandler'
import bindUtilsMethods from './methods/bindUtils'
import bindPosterMethods from './methods/bindPoster'

let amapManager = new AMapManager();

export default {
  data() {
    return {
      myObject: {},
      mpCode: "",
      borderCardCounts: { right: 0, bottom: 0, left: 0, top: 0 },
      options: heatmapOptions,
      value: "",
      zoom: 10,
      center: [120.128847, 30.223938],
      amapManager,
      mapHeight: {},
      events: {
        complete: () => {
          let that = this;
          let currentMap = amapManager.getMap();
          that.currentMap = currentMap;
          let type = that.type;
          let currentArea = that.currentArea;
          if (type === "板块") {
            that.drawAreaPrice1(currentMap);
            that.drawDistrict(currentMap, true);
          } else if (type === "中签率") {
            that.drawAreaPrice(currentMap, type);
            that.drawDistrict(currentMap);
          } else if (type === "热度") {
            that.drawAreaPrice(currentMap, type);
            that.drawDistrict(currentMap);
          } else if (type === "板块热力") {
            that.drawDistrict(currentMap);
            that.drawHeatMap(currentMap);
          } else if (type === "控规") {
            that.drawArea(currentMap);
            that.drawDistrict(currentMap);
          } else if (type === "新房") {
            that.drawSubway(currentMap);
            that.drawSubway4(currentMap);
            that.drawNewReals(currentMap);
            that.drawAreaNew(currentMap);
            that.drawDistrict(currentMap);
          } else if (type === "打印地图") {
            that.drawSubway(currentMap);
            that.drawSubway4(currentMap);
            that.drawNewReals2(currentMap);
            that.drawAreaNew2(currentMap);
            that.drawDistrict(currentMap);
          } else if (type === "待首开") {
            that.drawSubway(currentMap);
            that.drawSubway4(currentMap);
            that.drawNewReals(currentMap);
            that.drawAreaNew(currentMap);
            that.drawLandDeal(currentMap);
            that.drawDistrict(currentMap);
          } else if (type === "土拍") {
            that.drawSubway(currentMap);
            that.drawSubway4(currentMap);
            that.drawAreaNew(currentMap);
            that.drawLandDeal(currentMap);
            that.drawDistrict(currentMap);
          } else if (type === "土拍圆点") {
            this.drawBaseCover2(currentMap);
            that.drawAreaPrice1(currentMap);
            that.drawDistrict(currentMap, true);
            that.drawLandDealWithCard(currentMap);
          } else if (type === "公示登记") {
            that.drawSubway(currentMap);
            that.drawSubway4(currentMap);
            that.drawNewReals(currentMap);
            that.drawAreaNew(currentMap);
            that.drawDistrict(currentMap);
          } else if (type === "二手房") {
            that.drawSchoolArea(currentMap);
          } else if (type === "地标") {
            that.getLandmarks(currentMap);
          } else if (type === "板块规划") {
          } else if (type === "高架") {
            that.drawHighway(currentMap);
          } else if (type === "getBounds") {
            let bounds = currentMap.getBounds();
            console.log("bounds", bounds);
          } else if (type === "value") {
            that.drawValueMap(currentMap);
          } else if (type === "科创大走廊") {
            that.drawKCDZL(currentMap);
          } else if (type === "板块地图土拍") {
            that.drawDistrict(currentMap, true);
            that.drawAreaPrice1(currentMap);
            that.drawLandDeal(currentMap, true);
          } else if (type === "周学区热度和价格") {
            that.drawSchoolRealsHot(currentMap, "本周");
            that.drawNewDistrict(currentMap);
          } else if (type === "月学区热度和价格") {
            that.drawSchoolRealsHot(currentMap, "本月");
            that.drawNewDistrict(currentMap);
          } else if (type === "周板块热度和价格") {
            that.drawAreaAllHot(currentMap, "本周");
            that.drawNewDistrict(currentMap);
          } else if (type === "月板块热度和价格") {
            that.drawNewDistrict(currentMap);
            that.drawAreaAllHot(currentMap, "本月");
          } else if (type === "单个板块地图") {
            that.drawOneAreaAll(currentMap, currentArea.id);
          } else if (type === "单个学区地图") {
            that.drawOneSchoolAll(currentMap, currentArea.id);
          } else if (type === "杭州倒挂地图") {
            that.drawDaoguaAll(currentMap);
          } else if (type === "板块配套") {
            that.drawAreaPt(currentMap, "全部");
          } else if (type === "板块规控及重要规划") {
            that.drawAreaGkPlan(currentMap);
          } else if (type === "板块新盘分布") {
            that.drawAreaNewEstate(currentMap);
          }
          console.log("加载完成");
        },
        moveend: () => {
          let that = this;
          let zoom = that.currentMap.getZoom();
          let list = that.currentMap.getAllOverlays("marker");
          for (let i = 0; i < list.length; i++) {
            if (list[i].w.location_id) {
              if (zoom >= 15) {
                list[i].show();
              } else {
                list[i].hide();
              }
            }
          }
        },
        rightclick: (e) => {
          if (this.type === "板块规划") {
            console.log("右点击地图");
            let lnglat = e.lnglat.lng + "|" + e.lnglat.lat;
            this.drawLandPlan(this.currentMap, lnglat);
          }
        },
      },

      windowHeight: 800,
      windowWidth: 1200,

      subwayName,
      subwayColor,
      subwayStatus,
      sublines,
      curline: "",

      debugMode: false,
      colorPtMap,
      colorNEMap,
      colorKgMap,
      colorMap,

      realMarkers: {},
      currentMap: null,
      heatmap: null,
      max: null,
      radius: 30,

      currentArea: "",
      type: "",

      realLngLat: "",

      showedCells: [],

      landMarkers: {},
      schoolMarkers: {},

      currentZoom: 10,

      showedLandImages: [],

      areaList: [],
      areaIdList: [],

      sizeLevel: 1,

      widthSet: "",
      heightSet: "",

      estate_id: "",
      valueType: "",
      searchOption: {
        city: "杭州",
        citylimit: true,
      },
      markers: [],
      city: "",
      pttype: "全部",
    };
  },
  created() {
    this.$store.commit("SET_NOGLOBALCITY", true);
    let height = window.innerHeight;
    let obj = this.$route.params;
    if (!obj.type) {
      obj = this.$route.query;
    }
    let type = obj.type;
    let area = obj.area;
    this.currentArea = area;
    this.estate_id = obj.estate_id;
    this.valueType = obj.valueType;
    this.type = type;
    let cMap = {
      杭州: [120.17828, 30.209437],
      苏州: [120.619585, 31.299379],
    };
    let city = this.$store.state.Counter.city || "杭州";
    this.city = city;
    this.searchOption.city = city;
    let cityCenter = cMap[city];
    if (
      [
        "板块",
        "中签率",
        "热度",
        "板块热力",
        "板块地图土拍",
        "土拍圆点",
        "板块地图内容（二手/新房）",
        "板块库存分析地图（二手房）",
        "杭州新房地铁分布图",
        "低密楼盘分布地图",
        "豪宅楼盘分布地图",
      ].includes(type)
    ) {
      this.center = cityCenter;
      this.zoom = 13;
      this.windowHeight = 4400;
      this.windowWidth = 6500;
      if (city === "苏州") {
        this.center = [120.650185, 31.382678];
        this.zoom = 12;
        this.windowHeight = 5500;
        this.windowWidth = 5000;
      } else if (city === "上海") {
        if (this.currentArea === "全城左") {
          this.center = [121.120454, 31.089017];
          this.windowWidth = 5000;
        } else if (this.currentArea === "全城右") {
          this.center = [121.720454, 31.089017];
          this.windowWidth = 5000;
        } else {
          this.center = [121.420454, 31.089017];
          this.windowWidth = 10000;
        }
        this.zoom = 14;
        this.windowHeight = 10000;
      }
    } else if (type === "控规") {
      this.center = cityCenter;
      this.zoom = 12;
      this.windowHeight = height;
    } else if (
      [
        "新房",
        "待首开",
        "公示登记",
        "土拍",
        "杭州倒挂地图",
        "打印地图",
      ].includes(type)
    ) {
      this.zoom = 14;
      if (this.currentArea === "余杭区") {
        this.center = [120.107647, 30.334527];
        this.windowHeight = 4000;
        this.windowWidth = 5500;
      } else if (this.currentArea === "萧山区") {
        this.center = [120.365439, 30.171065];
        this.windowHeight = 3200;
        this.windowWidth = 4500;
      } else if (this.currentArea === "滨江区") {
        this.center = [120.192662, 30.184495];
        this.windowHeight = 1500;
      } else if (this.currentArea === "钱塘新区") {
        this.center = [120.461269, 30.298242];
        this.windowHeight = 1500;
        this.windowWidth = 4200;
      } else if (this.currentArea === "富阳区") {
        this.center = [119.965468, 30.090651];
        this.windowHeight = 2600;
        this.windowWidth = 2600;
      } else if (this.currentArea === "临安区") {
        this.center = [119.763165, 30.248483];
        this.windowHeight = 1500;
        this.windowWidth = 2500;
      } else if (this.currentArea === "西湖区") {
        this.center = [120.082627, 30.222455];
        this.windowHeight = 3500;
        this.windowWidth = 2000;
      } else if (this.currentArea === "拱墅区") {
        this.center = [120.146228, 30.341713];
        this.windowHeight = 1500;
      } else if (this.currentArea === "江干区") {
        this.center = [120.221158, 30.290996];
        this.windowHeight = 2500;
      } else if (this.currentArea === "上城区") {
        this.center = [120.181655, 30.240232];
        this.windowHeight = height;
      } else if (this.currentArea === "下城区") {
        this.center = [120.179338, 30.293606];
        this.windowHeight = height;
      } else if (this.currentArea === "全城") {
        this.windowHeight = 5000;
        this.windowWidth = 8000;
        if (city === "苏州") {
          this.center = [120.569185, 31.162678];
          this.windowHeight = 11300;
          this.windowWidth = 8900;
        }
      } else if (this.currentArea === "全城左") {
        this.center = [119.890667, 30.293606];
        this.windowHeight = 11000;
        this.windowWidth = 5550;
        if (city === "苏州") {
          this.center = [120.38033875, 31.162678];
          this.windowHeight = 11300;
          this.windowWidth = 4450;
        }
      } else if (this.currentArea === "全城右") {
        this.center = [120.367027, 30.293606];
        this.windowHeight = 11000;
        this.windowWidth = 5550;
        if (city === "苏州") {
          this.center = [120.75803125, 31.162678];
          this.windowHeight = 11300;
          this.windowWidth = 4450;
        }
      }
    } else if (type === "二手房") {
      this.zoom = 16;
      if (this.currentArea === "余杭区") {
        this.center = [120.107647, 30.334527];
        this.windowHeight = 8000;
        this.windowWidth = 10000;
      } else if (this.currentArea === "萧山区") {
        this.center = [120.326129, 30.163607];
        this.windowHeight = 6000;
        this.windowWidth = 8000;
      } else if (this.currentArea === "滨江区") {
        this.center = [120.181718, 30.185793];
        this.windowHeight = 2800;
        this.windowWidth = 2500;
      } else if (this.currentArea === "钱塘新区") {
        this.center = [120.461269, 30.298242];
        this.windowHeight = 3000;
        this.windowWidth = 7000;
      } else if (this.currentArea === "富阳区") {
        this.center = [119.965468, 30.090651];
        this.windowHeight = 5000;
        this.windowWidth = 5000;
      } else if (this.currentArea === "临安区") {
        this.center = [119.763165, 30.248483];
        this.windowHeight = 3000;
        this.windowWidth = 5000;
      } else if (this.currentArea === "西湖区") {
        this.center = [120.082627, 30.222455];
        this.windowHeight = 7000;
        this.windowWidth = 4000;
      } else if (this.currentArea === "拱墅区") {
        this.center = [120.146228, 30.341713];
        this.windowHeight = 3000;
        this.windowWidth = 2900;
      } else if (this.currentArea === "江干区") {
        this.center = [120.221158, 30.290996];
        this.windowHeight = 5000;
        this.windowWidth = 3500;
      } else if (this.currentArea === "上城区") {
        this.center = [120.179853, 30.237414];
        this.windowHeight = 1200;
      } else if (this.currentArea === "下城区") {
        this.center = [120.179209, 30.305833];
        this.windowHeight = 2800;
      } else if (this.currentArea === "全城") {
        this.windowHeight = 5000;
        this.windowWidth = 8000;
      }
    } else if (type === "地标") {
      this.zoom = 13;
      this.windowHeight = height;
      this.realLngLat = obj.center;
      this.center = obj.center.split("-")[0].split("|");
    } else if (type === "板块规划") {
      this.center = cityCenter;
      this.zoom = 12;
      this.windowHeight = height;
    } else if (type === "高架") {
      this.center = cityCenter;
      this.zoom = 12;
      this.windowHeight = height;
    } else if (type === "地铁图") {
      this.zoom = 14;
      this.windowHeight = height;
      this.windowWidth = window.innerWidth;
    } else if (type === "getBounds") {
      this.center = [117.366525, 39.398487];
      this.zoom = 12;
      this.windowHeight = 6500;
      this.windowWidth = 4400;
    } else if (type === "value") {
      this.center = cityCenter;
      this.zoom = 12;
      this.windowHeight = height;
    } else if (type === "科创大走廊") {
      this.zoom = 14;
      this.center = [119.852333, 30.269042];
      this.windowHeight = 6500;
      this.windowWidth = 7000;
    } else if ((type === "周学区热度和价格") | (type === "月学区热度和价格")) {
      this.center = [120.14528, 30.255999];
      this.zoom = 15;
      this.windowHeight = 7000;
      this.windowWidth = 8000;
    } else if ((type === "周板块热度和价格") | (type === "月板块热度和价格")) {
      this.center = cityCenter;
      this.zoom = 13;
      this.windowHeight = 5000;
      this.windowWidth = 7000;
    } else if (type === "单个板块地图") {
      this.center = area.center.split("-")[0].split("|");
      this.zoom = 13;
      this.windowHeight = 5000;
      this.windowWidth = 7000;
    } else if (
      ["板块配套", "板块新盘分布", "板块规控及重要规划"].includes(type)
    ) {
      this.center = area.center.split("-")[0].split("|");
      this.zoom = 14;
      this.windowHeight = height;
      this.windowWidth = window.innerWidth;
    } else if (type === "单个学区地图") {
      this.center = [120.14528, 30.255999];
      this.zoom = 15;
      this.windowHeight = 7000;
      this.windowWidth = 8000;
    }
  },
  mounted() {
    let that = this;
    if (that.type === "控规") {
      that.$axios
        .get(that.$url_prefix + "queryAreaByLevel", {
          params: {
            level: "板块",
            projection: "-_id id area_name district",
          },
        })
        .then(function (res) {
          console.log(3333, res);
          let areaList = res.data.data;
          let areaMap = {};
          areaList.forEach((x) => {
            if (!areaMap[x.district]) {
              areaMap[x.district] = [];
            }
            areaMap[x.district].push(x);
          });
          let result = [];
          for (let key in areaMap) {
            result.push({
              label: key,
              options: areaMap[key],
            });
          }
          that.areaList = result;
        })
        .catch((err) => {
          console.log("query area fail", err);
        });
    }
  },
  methods: {
    // 导入所有方法模块
    ...subwayMethods,
    ...bindDistrictMethods,
    ...bindAreaMethods,
    ...bindEstateMethods,
    ...bindLandMethods,
    ...bindHeatmapMethods,
    ...bindFacilityMethods,
    ...bindPlanMethods,
    ...bindSpecialMethods,
    ...bindHandlerMethods,
    ...bindUtilsMethods,
    ...bindPosterMethods,

    // UI 交互方法
    onSearchResult(pois) {
      if (pois.length > 0) {
        let { lng, lat } = pois[0];
        this.markers = [lng, lat];
      }
    },
    resetWindow() {
      if (this.widthSet) {
        this.windowWidth = this.widthSet;
      }
      if (this.heightSet) {
        this.windowHeight = this.heightSet;
      }
    },
    changeSize() {
      this.sizeLevel++;
    },
  },
  beforeDestroy() {
    this.$store.commit("SET_NOGLOBALCITY", false);
  },
};
</script>

<style>
.makeLocationImage {
  width: 100%;
  font-family: "STXihei";
}

.makeLocationImage #make_container {
  width: 100%;
}
.map-search-box {
  position: absolute !important;
  left: 0;
  top: 0;
  border: 1px solid black;
}

.amap-marker-content {
  white-space: nowrap !important;
}

.realPrice {
  line-height: 16px;
  font-size: 14px;
  text-align: center;
  padding: 2px 2px;
  border-radius: 5px;
}

.oldPrice {
  background-color: #f9f917;
  line-height: 12px;
  font-size: 10px;
  text-align: center;
  padding: 2px 2px;
  border-radius: 5px;
}

.oldPrice1 {
  background-color: #ffaf24;
  line-height: 12px;
  font-size: 10px;
  text-align: center;
  padding: 2px 2px;
  border-radius: 5px;
}

.landDeal {
  background-color: #e6364e;
  line-height: 24px;
  font-size: 20px;
  text-align: left;
  padding: 5px;
  border-radius: 5px;
  min-width: 185px;
  max-width: 200px;
  white-space: normal;
}
.landDeal1 {
  background-color: #23c76d;
  line-height: 24px;
  font-size: 20px;
  text-align: left;
  padding: 5px;
  border-radius: 5px;
  min-width: 185px;
  max-width: 200px;
  white-space: normal;
}

.realPrice-c {
  margin-top: 3px;
}

.realPrice-a {
  margin-top: 1px;
}

.areaName {
  width: 85px;
  height: 85px;
  color: #000000;
  line-height: 16px;
  font-size: 15px;
  text-align: center;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.areaName1 {
  background-color: #ffaf24;
  font-size: 14px;
  text-align: center;
  padding: 2px 2px;
  border-radius: 5px;
}
.areaName2 {
  font-size: 30px;
  text-align: center;
  padding: 2px 2px;
  border-radius: 5px;
  font-weight: bolder;
}
.areaName3 {
  color: #333333;
  font-size: 24px;
  text-align: center;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 3px dashed #fde247;
  background: rgba(253, 226, 71, 0.4);
}
.light {
  font-size: 16px;
}

.shape-container {
  position: relative;
  text-align: left;
}

.rectangle {
  font-size: 14px;
  color: #fff;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.reclight {
  color: #000000;
  text-align: center;
  border-radius: 5px;
  padding: 3px 6px 3px 6px;
}

.reclight_area {
  color: #000000;
  text-align: center;
  font-size: 20px;
  border-radius: 5px;
  padding: 3px 6px 3px 6px;
}

.rectangle1 {
  font-size: 14px;
  color: #fff;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.reclight1 {
  color: #000000;
  text-align: left;
  border-radius: 5px;
  padding: 3px 6px 3px 6px;
}
.ptbox {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  position: relative;
  font-size: 14px;
  color: #fff;
  text-align: left;
  font-style: normal;
  text-transform: none;
  line-height: 18px;
  z-index: 105;
}
.pttag {
  position: absolute;
  padding: 5px 10px;
  top: -2px;
  left: 50%;
  transform: translate(-50%, -100%);
}
.pttagtri {
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translate(-50%, 70%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}
.pt-tag {
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
  color: #fff;
  text-align: left;
  font-style: normal;
  text-transform: none;
  line-height: 18px;
  z-index: 105;
}
.triangle {
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 0;
  height: 0;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-top: 16px solid;
}
.newEstate {
  display: flex;
  align-items: center;
}

.newEstate2 {
  background-color: #fde247;
  padding: 10px;
  font-size: 24px;
  text-align: center;
  border-radius: 13px;
}

.expect {
  width: 25px;
  height: 25px;
  font-size: 18px;
  text-align: center;
  line-height: 25px;
  background-color: #7fff88;
  border-radius: 50%;
}

.color-note {
  position: fixed;
  top: 50px;
  left: 20px;
}

.color-note div {
  line-height: 30px;
  width: 150px;
  text-align: center;
}

.choose-area {
  position: fixed;
  top: 20px;
  left: 20px;
}
.color-right {
  position: fixed;
  top: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 15px;
  background-color: #ffffff;
}
.color-right-btn {
  position: absolute;
  bottom: -40px;
  background-color: #ffffff;
  padding: 10px 5px;
}
.color-item {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.color-circle {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}
.color-cell {
  width: 12px;
  height: 8px;
  margin-right: 5px;
}
.loc1 {
  background-color: #e479d8;
  font-size: 14px;
  text-align: center;
  padding: 2px 2px;
  border-radius: 5px;
}
.loc2 {
  background-color: #3daa2b;
  font-size: 14px;
  text-align: center;
  padding: 2px 2px;
  border-radius: 5px;
}

.circle {
  background-color: red;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.land-wait {
  background-color: #fdf05f;
  min-width: 348px;
  line-height: 1;
  overflow: hidden;
  border-radius: 5px;
}
.land-wait-head {
  text-align: center;
  font-size: 24px;
  color: #fd3d3d;
  padding: 7px;
  font-weight: 900;
}
.land-wait-box {
  background-color: rgba(255, 0, 0, 0.5);
  display: grid;
  grid-template-columns: 174px 174px;
  font-size: 16px;
  color: #fdfcfc;
}
.land-wait-box > div {
  padding: 7px;
}
.land-wait1 {
  line-height: 1;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 0rpx 0rpx 0rpx 0rpx;
  border: 3px solid #000000;
  box-sizing: border-box;
  overflow: hidden;
  z-index: 1000;
}
.land-wait1-head {
  text-align: center;
  font-size: 65px;
  color: #3D3D3D;
  padding: 20px;
  font-weight: 900;
  background-color: #FDE247;
}
.land-wait1-box {
  background: rgba(255,255,255,0.7);
  font-size: 45px;
  color: #333333;
}
.land-wait1-box > div {
  padding: 20px;
  font-weight: 900;
}
.circle1 {
  background-color: #333333;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.image-background2 {
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: rgba(169, 169, 169, 0.8);
  z-index: 999;
  left: 0;
  top: 0;
}

.image-preview2 {
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  text-align: center;
  border: 1px solid #865ea7;
  padding: 10px;
  display: inline-block;
}

.close2 {
  padding: 5px;
  position: absolute;
  z-index: 100;
  top: 0;
  right: 0;
  background-color: red;
}

.stationIcon1 {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.stationIcon1 > div {
  width: 10px;
  height: 10px;
  background-color: #ffffff;
  border-radius: 50%;
}
.stationIcon2 {
  width: 20px;
  height: 20px;
}
.stationIcon2 > img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/makeLocationImage/index.vue